import { Inject, Injectable, forwardRef } from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }              from '../api/api.service';
import { ConfirmService }          from '../messages/confirm/confirm.service';
import { WsApiKeysModel }          from './models/ws-api.keys';
import { WsApiSecretKeyComponent } from './ws-api.secret-key.component';

@Injectable({
  providedIn: 'root'
})
export class WsApiService {
  public title = this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.PODIUM');

  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService      : ApiService,
    @Inject(forwardRef(() => ConfirmService)) private confirmService  : ConfirmService,
    private modalService    : NgbModal,
    private translateService: TranslateService
  ) {}

  activate () : ng.IPromise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
        name: this.title
      }))
      .then(() => this.apiService.get('/company_integrations/enable_ws_api'));
  }

  deactivate () : ng.IPromise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.REMOVE_INTEGRATION', {
        name: this.title
      }))
      .then(() => this.apiService.get('/company_integrations/disable_ws_api'));
  }

  generateApiKey () : ng.IPromise<any> {
    return this.confirmService.generic(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.GENERATE_NEW_KEY'), '', {
        cancelText : this.translateService.instant('GENERAL_SPACE.BUTTON.CANCEL'),
        confirmText: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.GENERATE')
      })
      .then(() => this.apiService.get('/company_integrations/generate_workshop_api_key'))
      .then(( keys : WsApiKeysModel ) => {
        const modal =  this.modalService.open(WsApiSecretKeyComponent, {
          size: 'lg'
        });

        modal.componentInstance.keys = keys;

        return modal.result;
      });
  }
}